import {Component} from '@angular/core';
import {BaseComponent} from "../../../../../../../base/components/base.component";
import {IPage} from "../../../../../../../base/models/pagination.model";
import {INotification, Priorities} from "../../models/notification.model";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../base/services/subscription-container.service";
import {NotificationService} from "../../services/notification.service";
import {IParams} from "../../../../../../../base/endpoints/iparams";
import {EventKey} from "../../../../../../../registry/event.key";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: 'app-sticky-notifications',
  templateUrl: './sticky-notifications.component.html',
  styleUrls: ['./sticky-notifications.component.scss']
})
export class StickyNotificationsComponent extends BaseComponent {
  notifications: IPage<INotification>
  response: string | null

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private notificationService: NotificationService
  ) {
    super(eventBus, router, subContainer)
  }

  protected componentName(): string {
    return StickyNotificationsComponent.name;
  }

  ngOnInit(): void {
    this.fetchMyNotifications(
      {
        sticky: true,
        page: 0,
        size: 10
      }
    )
  }

  onResponseSubmit(id: number) {
    if (this.response == null || this.response.length == 0) return
    this.loading = true
    let key = this.componentKey(EventKey.NOTIFICATIONS.RESPOND(id))
    this.notificationService.respond(key, id, {response: this.response})
    this.subscribe(key, null, (value, meta) => {
      this.loading = false
      this.increaseClickCount(id)
      this.fetchMyNotifications(
        {
          sticky: true,
          page: 0,
          size: 10
        }
      )
    })
  }

  private fetchMyNotifications(params: IParams) {
    this.loading = true
    let key = this.componentKey(EventKey.NOTIFICATIONS.FETCH_MY_NOTIFICATIONS())
    this.notificationService.fetchMyNotifications(key, params)
    this.subscribe(key, null, (value, meta) => {
      this.notifications = meta.data
      this.loading = false
      // increase view count for each item
      this.notifications.content.forEach(n => {
        this.increaseViewCount(n.id)
      })
    })
  }


  dismissNotification(id: number) {
    this.loading = true
    let key = this.componentKey(EventKey.NOTIFICATIONS.MAKE_STICKY())
    this.notificationService.makeSticky(key, id, false)
    this.subscribe(key, null, (value, meta) => {
      this.loading = false
      this.increaseClickCount(id)
      this.fetchMyNotifications(
        {
          sticky: true,
          page: 0,
          size: 10
        }
      )
    })
  }

  increaseViewCount(id: number) {
    this.loading = true
    let key = this.componentKey(EventKey.NOTIFICATIONS.INCREASE_VIEW_COUNT(id))
    this.notificationService.increaseViewCount(key, id)
    this.subscribe(key, null, (value, meta) => {
      this.loading = false
    })
  }

  increaseClickCount(id: number) {
    this.loading = true
    let key = this.componentKey(EventKey.NOTIFICATIONS.INCREASE_CLICK_COUNT(id))
    this.notificationService.increaseClickCount(key, id)
    this.subscribe(key, null, (value, meta) => {
      this.loading = false
    })
  }

  resolveAlertIcon(priority: string) {
    switch (priority) {
      case Priorities.IMMEDIATE:
        return 'mdi-block-helper'
      case Priorities.URGENT:
        return 'mdi-block-helper'
      case Priorities.HIGH:
        return 'mdi-alert-outline'
      case Priorities.NORMAL:
        return 'mdi-bullseye-arrow'
      case Priorities.LOW:
        return 'mdi-alert-circle-outline'
      default:
        return 'mdi-alert-circle-outline'
    }
  }

  protected readonly Editor = ClassicEditor;
}
